import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { store, persistor } from "./redux/store"; // ✅ import persistor
import { PersistGate } from "redux-persist/integration/react"; // ✅ import PersistGate
import { BrowserRouter as Router } from "react-router-dom";


const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}> {/* ✅ PersistGate wraps Router + App */}
      <Router>
        <App />
      </Router>
    </PersistGate>
  </Provider>
);
